import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'keys',
  pure: false
})
export class KeysPipe implements PipeTransform {
  transform(value: any, args: any[] = null): any {
    return value === undefined ? [] : Object.keys(value); // .map(key => value[key]);
  }
}



// WEBPACK FOOTER //
// D:/Projects/bid/frontend/src/app/shared/pipes/keys.pipe.ts